<template>
  <div class="relative w-full">
    <el-image
      class="w-full h-full"
      :src="backgroundImage"
      fit="cover"
      style="object-position: center"
    ></el-image>
    <!-- <div
      class="absolute top-1/2 -translate-y-1/2 w-auto h-auto left-[19.27vw] flex flex-col justify-start gap-[1.04vw]"
    >
      主标题框
      <div class="h-auto flex flex-col justify-start items-start">
        <div
          class="text-left justify-start text-[2.3vw] text-[#FFFFFF] font-harmony font-bold"
        >
          白名单赛事
        </div>
      </div>
      副标题框
      <div class="h-auto flex flex-col justify-start items-start">
        <div
          class="text-left justify-start text-[0.94vw] text-[#FFFFFF] font-harmony font-light"
        >
          教育部认证赛事+民航局资质双护航，升学含金量拉满
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "competition-module1",
  data() {
    return {
      backgroundImage: `https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-study/competition/module1/sample2.png`,
    };
  },
  methods: {
    // 动态加载图片，根据文件名选择合适的格式
    getImage(imageName) {
      const formats = ["png", "jpg", "jpeg", "webp"];
      for (let format of formats) {
        try {
          return require(`@/assets/images/Competition/module1/${imageName}.${format}`);
        } catch (e) {
          continue;
        }
      }
      return "";
    },
  },
};
</script>

<style scoped>
</style>